module.exports = __WEBPACK_EXTERNAL_MODULE_16__;


//////////////////
// WEBPACK FOOTER
// external "dojo/Deferred"
// module id = 16
// module chunks = 0